export const DEFAULT_DATE_FORMAT = 'MM.dd.yyyy';
